import axiosClient from "utils/api";
const URI = "/admin/event";

export const getEventList = async (payload) => {
  const URL = `${URI}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during Get Event List:", error);
    throw error;
  }
};

export const getEventDetail = async (payload) => {
  const URL = `${URI}/${payload.id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during Get event detail:", error);
    throw error;
  }
};

export const getEventCheckIn = async (payload) => {
  try {
    const response = await axiosClient().request({
      url: `${URI}/checkin`,
      method: "get",
      params: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during Get event check-in:", error);
    throw error;
  }
};
